module.exports = __webpack_public_path__ + "static/media/sign_up_1.30b5069d.jpg";